// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { residentsUsersModel } from '@/firebase/residents-firebase-config'

export const GetUser = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        residents_user: null,
        get_nestd_resident_complete: false

    }),

    /*
	**  Methods
    */
    
    methods: {

        getUserHandler: function(resident_id) {

            try {

                residentsUsersModel.where('relationships.nestd_resident', '==', resident_id).get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    /*
                    **  Loop through em
                    */

                    snapshot.forEach(doc => {

                        /*
                        **  Set the prop
                        **  @prop: @here
                        */

                        this.residents_user = doc.data();

                    });

                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.get_nestd_resident_complete = true;

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get the Residents User from the Residents Portal.',
                        errorType: 'Firestore Database',
                        section: 'Events/Nestd-Reidents',
                        uid: '3cDLQC55r0chWSrPaExS',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Perform the Query to Get the Residents User Document from the Residents Portal.',
                    errorType: 'Firestore Database',
                    section: 'Events/Nestd-Reidents',
                    uid: 'CoikvdH6k82UUQvv8p69',
                    error: e
                });

            }

        }

    }

}